import React from "react";
import ReactDOM from "react-dom";

const Blocker = ({children, el}) => {
    return ReactDOM.createPortal(
        children,
        el
    )
};

export default (WrappedComponent) => {
    return class BlockerComponent extends React.Component {

        constructor() {
            super();
            this.state = {showBlocker: false};
            this._events = 0;
        }

        showBlocker = (callback) => {
            this.registerEventShow();
            this.setState({showBlocker: true}, callback);
        };

        hideBlocker = () => {
            this.deleteShowEvent();
            if (this._events === 0)
                this.setState({showBlocker: false});
        };

        registerEventShow = () => {
            this._events++
        };

        deleteShowEvent = () => {
            this._events--;
        };

        render() {

            return (
                <React.Fragment>
                    <WrappedComponent {...this.props} showBlocker={this.showBlocker} hideBlocker={this.hideBlocker}/>
                    <Blocker el={document.body}>
                        <div className="blocker" style={{display: this.state.showBlocker ? "block" : "none"}}/>
                    </Blocker>
                </React.Fragment>
            )

        }

    }
}


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/common/blocker/BlockerComponent.js